// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"629c8186","145":"acc41efc","174":"0ca221a0","282":"5e07d2f8","307":"9dca4323","336":"e82bf901","488":"f1b8c234","628":"29e4eed6","635":"d3c31ab5","641":"1f19d843","672":"325c743a","936":"b96b60cd","998":"63d8cf0e"}[chunkId] + ".js";
};